import { makeStyles, styled } from "@cirrus/ui-kit/src"
import { Grid } from "@mui/material"
import React from "react"

import { FiltersGroup } from "./FiltersGroup"

const useStyles = makeStyles(() => ({
  autocompleteFilter: {
    "& .MuiFormLabel-root": {
      fontSize: "14px",
      lineHeight: "24px"
    },
    "& .Mui-focused": {
      "& .MuiFilledInput-root": {
        flexWrap: "wrap",
        "& .MuiAutocomplete-tag": {
          display: "flex"
        },
        "& input": {
          marginBottom: "4px",
          minHeight: "18px",
          "&:focus": {
            padding: "4px 7px !important"
          },
          "&::placeholder": {
            color: "transparent"
          }
        }
      }
    },
    "& .MuiFilledInput-root": {
      "& .MuiAutocomplete-tag": {
        margin: "1px",
        height: "24px",
        marginTop: "0",
        backgroundColor: "unset",
        "& span": {
          lineHeight: "18px"
        },
        "&:not(:first-of-type)": {
          display: "none"
        },
        "&:hover": {
          "& .MuiSvgIcon-root": {
            opacity: .9,
            "&:hover": {
              opacity: 1
            }
          }
        },
      },
      "& input": {
        padding: "7px 4px !important",
        width: "fit-content",
        backgroundColor: "unset",

        "&:hover": {
          backgroundColor: "unset"
        }
      },
      display: "flex",
      maxWidth: "fit-content",
      minWidth: "100%",
      minHeight: "44px !important",
      paddingTop: "19px !important"
    },
    "& .MuiAutocomplete-root": {
      marginTop: "8px",

      "& .MuiFormControl-root": {
        background: "#fff"
      }
    }
  }
}))

const Label = styled("div")({
  fontSize: "14px"
})

export const AutocompleteFilterWrapper = (props: IProps) => {

  const { autocompleteFilter } = useStyles()

  return (
    <FiltersGroup xs={12}>
      <Grid container justifyContent="start" spacing={1} className={autocompleteFilter}>
        <Grid xs={12}>
          {props.hideLabel ? null : <Label>{props.title}</Label>}
          {props.children}
        </Grid>
      </Grid>
    </FiltersGroup>
  )
}

interface IProps {
  name: string;
  title: string;
  children: any;
  hideLabel?: boolean;
}
